// import Colors from '../../../../Configs/colors';

const styles = {
  root: {
    // boxSizing: 'border-box',
    paddingBottom: 20,
  },
};

export default styles;
